export const dataUrlToFile = (dataUrl: string, fileName: string): File => {
  const [header, base64] = dataUrl.split(',')
  const mimeType = header.match(/:(.*?);/)?.[1] || ''

  const byteString = atob(base64)
  const bytes = new Uint8Array(byteString.length)

  for (let i = 0; i < byteString.length; i++) {
    bytes[i] = byteString.charCodeAt(i)
  }

  return new File([bytes], fileName, { type: mimeType })
}
